import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statusLozenge: {
		id: 'backlog.card-list.card.card-contents.status-field.status-field-static.status-lozenge',
		defaultMessage: 'status',
		description: 'Status',
	},
});
